 let parseURLParams = function(p){
    // console.log(p)
    let params = p.split('&').reduce((acc, curr) =>{
        const split = curr.split("=")
        acc[split[0]] = split[1]
        return acc
        }, {})
    return params
}
export default parseURLParams;